export default __webpack_public_path__ + "static/media/risik.29224e9e.png";